// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/core/place_types/government.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file proto/model/core/place_types/government.proto.
 */
export const file_proto_model_core_place_types_government = /*@__PURE__*/
  fileDesc("Ci1wcm90by9tb2RlbC9jb3JlL3BsYWNlX3R5cGVzL2dvdmVybm1lbnQucHJvdG8SBmNhcm1lbiq4AwoTR292ZXJubWVudFBsYWNlVHlwZRIlCiFHT1ZFUk5NRU5UX1BMQUNFX1RZUEVfVU5TUEVDSUZJRUQQABIjCh9HT1ZFUk5NRU5UX1BMQUNFX1RZUEVfQ0lUWV9IQUxMEAESJAogR09WRVJOTUVOVF9QTEFDRV9UWVBFX0NPVVJUSE9VU0UQAhIhCh1HT1ZFUk5NRU5UX1BMQUNFX1RZUEVfRU1CQVNTWRADEiYKIkdPVkVSTk1FTlRfUExBQ0VfVFlQRV9GSVJFX1NUQVRJT04QBBIrCidHT1ZFUk5NRU5UX1BMQUNFX1RZUEVfR09WRVJOTUVOVF9PRkZJQ0UQBRIxCi1HT1ZFUk5NRU5UX1BMQUNFX1RZUEVfTE9DQUxfR09WRVJOTUVOVF9PRkZJQ0UQBhI7CjdHT1ZFUk5NRU5UX1BMQUNFX1RZUEVfTkVJR0hCT1JIT09EX1BPTElDRV9TVEFUSU9OX0pBUEFOEAcSIAocR09WRVJOTUVOVF9QTEFDRV9UWVBFX1BPTElDRRAIEiUKIUdPVkVSTk1FTlRfUExBQ0VfVFlQRV9QT1NUX09GRklDRRAJQihaJmdpdGh1Yi5jb20veXVuYWNhYmEvY2FybWVuL3Byb3RvL21vZGVsYgZwcm90bzM");

/**
 * Describes the enum carmen.GovernmentPlaceType.
 */
export const GovernmentPlaceTypeSchema = /*@__PURE__*/
  enumDesc(file_proto_model_core_place_types_government, 0);

/**
 * Government-related place types
 *
 * @generated from enum carmen.GovernmentPlaceType
 */
export const GovernmentPlaceType = /*@__PURE__*/
  tsEnum(GovernmentPlaceTypeSchema);

